import React from "react";
import { PageHeader } from "../../../components";

export default function CHAIRMANSWIMMING() {
  return (
    <div className="page-content">
      <PageHeader title="Management Details" page="management details" />
      {/* <!-- Content --> */}
      <div className="page-content">
        {/* <!-- Breadcrumb row END --> */}
        {/* <!-- contact --> */}
        <div className="content">
          {/* <!-- About Company --> */}
          <div className="section-fullbg-gray content-inner bg-gray ">
            <div className="container">
              <div className="row">
                <div className="col-md-5 col-sm-12 hidden-sm">
                  <img
                    src="./assets/images/members/LCC2.JPG"
                    alt=" "
                    className="m-b30"
                    width="440"
                  />
                </div>
                <div className="col-md-7 col-sm-12">
                  <h3 className="h3">MR. AYOKO OLUSOJI HENRY</h3>
                  <div className="dlab-separator bg-primary"></div>
                  <h4 className="font-weight-3 00">
                    My name is Ayoko Olusoji Henry. I am currently Chairman,
                    Swimming Section. I am an astute entrepreneur with bias for
                    export trade and merchandise. I have served in various
                    capacities, such as E.O., Secretary and Vice Chairman
                    respectively. Always ready to give service to humanity.
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- contact area  END --> */}
      </div>
    </div>
  );
}
